<template>
	<div class="all-product">
		<div class="container">
			<div class="row">
				<div class="col-12 p-md-0">
					<div class="col-12 p-0 pb-4">
						<div class="container p-0">
							<div class="row">
								<div class="container mt-4">
									<div class="row">
										<div class="col-12 list-product pl-0 pr-0">
											<div class="col-12 d-flex">
												<div class="col-12 col-md-6 col-lg-6 p-lg-5 p-md-4 pb-md-5 pl-3 pr-3 pt-2 pb-5">
													<div class="color-white font-size-18 font-size-sm-14 font-weight-bold pt-4">Produk Terbaik Milagros</div>
													<div class="input-group pt-3">
														<div class="input-group-prepend">
															<span class="input-group-text background-white search-prepend color-purple pl-3"><i class="fas fa-search"></i></span>
														</div>
														<input type="text" class="form-control input-search" placeholder="Nama Produk" aria-label="Username" aria-describedby="basic-addon1" v-model="cariProduct.value" @keyup.enter="cari()">
													</div>
												</div>
												<div class="col-6 pt-3 d-md-block d-none">
													<div class="col-9 pt-4 m-auto"><img src="/assets/produk/list-produk.svg" class="img-fluid"></div>
												</div>
											</div>
										</div>
										<div class="col-12 text-center mt-lg-n4 mt-md-n2 mt-n1">
											<button class="btn background-purple rounded-pill color-white bounce pt-2" @click="scrollToProduct">
												<i class="fas fa-angle-double-down font-size-15 font-size-sm-12"></i>
											</button>
										</div>
									</div>
								</div>
								<div class="col-12 mt-3" id="category-product">
									<div class="col-12 mt-5 color-black pl-0 font-weight-bold font-size-16 font-size-sm-12">
										Kategori
									</div>
								</div>
								<div class="col-12 pt-md-3 pb-3">
									<carousel ref="carousel" id="owl-menu" class="col-12 pl-0 pr-0 pt-2 pb-2" :responsive="{0:{items:3},600:{items:4},1000:{items:6}}" :margin="0" :autoplay="false" :nav="false" :loop="false" :dots="false" v-show="Object.keys(dataCategory.results).length == 0">
										<div class="col-12 pl-0 pr-2" v-for="index in 3" :key="index">
											<button class="col-12 rounded hov-cus-shadow pt-3 pb-3 mb-2 mr-2 cursor-pointer box-category">
												<vcl :width="200" :height="100">
													<rect x="55" y="0" rx="1" ry="1" width="90" height="70"/>
													<rect x="30" y="80" rx="1" ry="1" width="140" height="20"/>
												</vcl>
											</button>
										</div>
									</carousel>
									<carousel ref="carousel" id="owl-menu" class="col-12 pl-0 pr-0 pt-2 pb-2" :responsive="{0:{items:3},600:{items:4},1000:{items:6}}" :margin="0" :autoplay="false" :nav="false" :loop="false" :dots="false" v-if="Object.keys(dataCategory.results).length > 0">
										<div class="col-12 pl-0 pr-2" v-for="(categories, index) in dataCategory.results" :key="index" @click="pilihCategory(categories.product_category_id, categories.product_category_name)">
											<button class="col-12 rounded hov-cus-shadow pt-3 pb-3 mb-2 mr-2 cursor-pointer" :class="categories.product_category_id == category.value ? 'box-category-active' : 'box-category' ">
												<div class="col-12 pl-0 pr-0 text-center category">
													<div class="col-12">
														<img :src="categories.product_category_image_filename" class="width-50 height-50 rounded" alt="">
													</div>
													<div class="col-12 pl-0 pr-0 font-size-11 font-size-md-9 font-size-sm-8 pt-2">
														{{ categories.product_category_name }}
													</div>
												</div>
											</button>
										</div>
									</carousel>
								</div>
								<div class="col-12">
									<div class="col-12 mt-2 mt-md-4 color-black pl-0 font-weight-bold font-size-16 font-size-sm-12">
										{{ namaCategory }}
									</div>
								</div>
								<div class="col-12 pl-4 pr-4 pl-md-3 pr-md-3" v-show="dataproductCategory.length == 0">
									<div class="row">
										<SkeletonStockist class="col-6 col-md-4 col-lg-3 mt-3 mt-md-4 pr-2 pr-md-3 pl-2 pl-md-3" v-for="n in 4" :key="'sekeleton'+n"/>
									</div>
								</div>
								<div class="container mt-4 text-center" v-if="dataproductCategory == 'error'">
									<div class="row">
										<div class="col-12 pb-2 background-white rounded cus-box-shadow">
											<div class="col-12 p-0 d-flex pb-2 pl-4">
												<div class="col-12 p-0">
													<div class="row">
														<div class="offset-md-4 col-md-4 offset-1 col-10 mt-1 pt-4 text-center">
															<img src="assets/icon/produk-belum-tersedia.svg" class="img-fluid">
														</div>
														<div class="col-12">
															<p class="font-size-sm-10 font-size-12 mt-4 mb-2">Produk belum tersedia untuk saat ini</p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-12" v-else>
									<div class="row">
										<div class="col-12 d-flex flex-wrap pr-0">
											<div class="col-6 col-md-4 col-lg-3 mt-3 mt-md-4 pl-0" v-for="(productCategory, index) in dataproductCategory" :key="index">
												<div class="col-12 pl-0 pr-0 output-search rounded">
													<div class="output-search-hover position-absolute rounded pt-5">
														<div class="col-12 text-center font-size-12 color-mila font-weight-bold pt-2 pt-md-3 font-size-sm-10">
															<b><span>{{productCategory.product_name}}</span></b>
														</div>
														<div class="col-12 p-0 text-center pt-2">
															<router-link :to="{ name: 'product', params: { code: productCategory.product_code }}" class="col-10 col-md-8 btn background-button-template rounded font-size-sm-7 color-white box-purple">
																Detail Produk
															</router-link>
														</div>
													</div>
													<div class="col-12 p-0 border output-search-nohover rounded cus-box-shadow">
														<div class="col-12 p-4 text-center">
															<img class="img-fluid img-thumb-stockist ma-md-height-220 height-sm-130 rounded" alt="stockist" :src="productCategory.product_image_filename">
														</div>
														<div class="col-12 pl-0 pr-0 desc-products">
															<div class="col-12 text-center font-size-12 font-size-sm-10 mt-n1">
																<b><span id="idMember">{{productCategory.product_name}}</span></b>
															</div>
															<div class="col-12 text-center color-mila font-size-12 font-size-sm-10 f-lato">
																<b><span id="idMember">{{productCategory.product_price | toRupiah}} / {{productCategory.product_unit}}</span></b>
															</div>
															<div class="col-12 text-center font-size-11 font-size-sm-9 pb-2 f-lato pb-3">
																<b><div id="idStockis">{{productCategory.product_weight | toKg}}</div></b>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 text-center pb-4 pt-2" v-if="pagination.next > 0">
						<a href="javascript:;" class="btn background-button-template box-purple" @click="tampilbanyak">
							<div class="text-capitalize color-white font-size-10">
								<i class="fas fa-sync mr-2"></i>
								<span class="">Muat lebih banyak</span>
							</div>
						</a>
					</div>
					<ml-partner-us></ml-partner-us>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import carousel from 'vue-owl-carousel';
import MlPartnerUs from '@/components/MlPartnerUs.vue';
import $ from 'jquery';
import { mapState, mapActions } from 'vuex';
import SkeletonStockist from '@/components/Skeleton/SkeletonStockist';

export default {
	name: 'AllProduct',
	components: {
		MlPartnerUs, carousel, SkeletonStockist
	},
	data () {
		return {
			nama_produk:'',
			namaCategory:'Produk Utama',
			cariProduct: {
				value:'',
				comparison:'like',
				type:'string',
				field:'product_name'
			},
			category: {
				value:'1',
				comparison:'=',
				type:'string',
				field:'product_product_category_id'
			},
			page: 1,
			limit: 8,
			params:[]
		}
	},
	computed : {
		...mapState('listProduct', ['dataCategory', 'dataproductCategory', 'pagination']),
	},
	methods: {
		...mapActions('listProduct', ['getAllCategory', 'getAllProduct']),
		scrollToProduct() {
			var cp = $('#category-product').offset().top
			cp -= 50
			$('html').scrollTop(cp)
		},
		pilihCategory(id, name) {
			this.params = []
			this.page = 1
			this.limit = 8
			this.category.value = id
			this.params.push(this.category)
			this.namaCategory = name
			this.getAllProduct({params:this.params , limit:this.limit, page:this.page})
			// this.getAllProduct(this.category)
		} ,
		tampilbanyak() {
			this.page++;
			this.getAllProduct({params:this.params , limit:8, page:this.page})
		},
		cari() {
			this.limit = 8
			this.params = []
			if(this.category.value) {
				this.params.push(this.category)
			}
			if(this.cariProduct.value) {
				this.params.push(this.cariProduct)
			}
			this.getAllProduct({params:this.params , limit:this.limit, page:1}).then(() => {
				this.cariProduct.value = ''
			})
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', 'Produk');
		this.getAllCategory().then(() => {
			this.params.push(this.category)
			this.getAllProduct({params:this.params , limit:this.limit, page:1})
		})
	}
}
</script>

<style>
.search-prepend {
	border-top-left-radius: 50rem;
	border-bottom-left-radius: 50rem;
	border-right: none;
}
.input-search {
	border-top-right-radius: 50rem;
	border-bottom-right-radius: 50rem;
	border-left: none;
}
.input-search:focus {
	border-color: #ced4da;
	box-shadow: none;
}
.list-product {
	background-image: url("/assets/produk/background-list-produk.png");
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
}
.box-category-active {
	background-image: linear-gradient(to right, #7C1CC6, #460C94);
	border: none;
}
.box-category {
	background-color: #fff;
	border: none;
}
.box-category-active:focus, .box-category:focus {
	border: none;
	outline: none;
	box-shadow: none;
}
.box-category-active .category {
	filter: brightness(0) invert(1);
}

@media (min-width: 426px) and (max-width:525px) {
	.box-category, .box-category-active {
		min-height: 8.3rem;
	}
}

@media (min-width: 600px) and (max-width: 767px) {
	.box-category, .box-category-active {
		min-height: 8.3rem;
	}
}

@media (min-width: 990px) and (max-width: 1200px) {
	.box-category, .box-category-active {
		min-height: 8.3rem;
	}
}
</style>